import { withTheme } from '@elixir/theme';
import React from 'react';
import {FieldComponent} from '../FieldComponent';
import cx from 'classnames';
import textAreaStyles from './TextAreaField-hashed.scss';
import inputStyles from '../InputField/InputField-hashed.scss';

/**
 * TextAreaField is a 'field' component that displays a label, control and message. It can be used to render
 * any HTML5 <textarea> element.
 */
export class TextAreaField extends FieldComponent {

    // explicitly defined due to docgen limitations
    render() {
        return super.render();
    }

    /**
     * Render readonly control for TextArea.
     *
     * @param {string} className - additional classes to be used
     * 
     * @returns {ReactElement} JSX for the control
     */
    renderControlReadOnly(className) {
        return super.renderControlReadOnly(cx(className, textAreaStyles.textAreaReadOnly));
    }

    /**
     * Render control for this component.
     * 
     * @param {string} inputType - HTML5 input type
     * @param {object} options - rendering options (like 'isInvalid', 'isValid', etc)
     *
     * @returns {ReactElement} JSX for the control
     */
    renderControl(inputType, options) {
        const {
            id, value, placeholder, disabled, required, theme, maxLength, rows, controlClassName
        } = this.props;
        const { translator } = this;
        const focusHandlers = this.getInputFocusHandlers();

        const combinedStyles = {...inputStyles, ...textAreaStyles};
        const themeStyles = theme.getStyles('TextArea', combinedStyles);
        const classes = cx(
            themeStyles.input,
            themeStyles.textArea,
            {
                disabled,
                invalid: !options.isValid
            },
            controlClassName
        );

        // Note: using the 'handleChange' callback from FieldComponent; no need to override for this control
        return (
            <textarea
                id={id}
                className={classes}
                placeholder={translator(placeholder)}
                value={value || ''}
                onChange={this.handleChange}
                {...focusHandlers}
                disabled={disabled}
                required={required}
                maxLength={maxLength}
                rows={rows}
                {...this.generateDataPathProperty()}
            />
        );
    }
}

export default withTheme(TextAreaField);
